import { FocusMetricDto } from '../../coaching-base/general';
import { MetricItem } from '../../coaching-tags/models/metric.coaching.model';
import { createAction } from '../../store.model';
import { Column, Row } from '../experimental.grid';

import {
    CellContext,
    ColumnContext,
    RowContext,
} from './kpi-set.observation.model';

export enum ActionType {
    COACHING_KPI_SET__RELOAD = 'COACHING_KPI_SET__RELOAD',
    COACHING_KPI_SET__RELOAD_RESULT = 'COACHING_KPI_SET__RELOAD_RESULT',
}

export interface KpiSetReloadAction {
    performerId: number;
    behaviourId: number;
    subBehaviourId: number;
    metrics: FocusMetricDto[];
    metricsLookup: MetricItem[];
    metricId?: number;
}

export const kpiSetReload = createAction<ActionType, KpiSetReloadAction>(
    ActionType.COACHING_KPI_SET__RELOAD,
);

export interface KpiSetReloadResultAction extends KpiSetReloadAction {
    gridColumns?: Array<Column<ColumnContext>>;
    gridRows?: Array<Row<RowContext, CellContext>>;
}

export const kpiSetReloadResult = createAction<
    ActionType,
    KpiSetReloadResultAction
>(ActionType.COACHING_KPI_SET__RELOAD_RESULT);
